
module.exports = {
  ui: {
    fields: ['title', 'date', 'status', 'summary'],
  },
  project: {
    items: 0,
  },
}
